import React, { useState } from 'react';
import './AddToCalendar.scss';
import { addToGoogleCalendar } from '../../../api/calender';
import { toast } from 'react-toastify';

interface Appointment {
  title: string;
  description: string;
  startTime: string;
  endTime: string;
  location: string;
  appointmentId?: number;
}

interface AddToCalendarProps {
  appointment: Appointment;
  manualAppointmentId?: number;
}

const AddToCalendar: React.FC<AddToCalendarProps> = ({ appointment, manualAppointmentId }) => {
  const [isLoading, setIsLoading] = useState(false);

  const getTokenFromQuery = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    if (token && token.length > 0) {
      return token;
    }
    const storedToken = sessionStorage.getItem('temp_token');
    if (storedToken) {
      const newUrl = `${window.location.pathname}?token=${storedToken}`;
      window.history.replaceState({}, '', newUrl);
      return storedToken;
    }
    return null;
  };

  const handleAddToCalendar = async () => {
    const finalAppointmentId = manualAppointmentId || appointment.appointmentId;
    
    if (!finalAppointmentId) {
      toast.error('No appointment ID available. Please contact support.');
      return;
    }

    const accessToken = getTokenFromQuery();
    
    if (!accessToken) {
      toast.error('Please log in to add appointments to your calendar');
      return;
    }

    setIsLoading(true);

    try {
      // Store the token temporarily for this API call
      const originalToken = localStorage.getItem('access_token');
      const originalSessionToken = sessionStorage.getItem('access_token');
      
      // Store the token from URL in both localStorage and sessionStorage
      localStorage.setItem('access_token', accessToken);
      sessionStorage.setItem('access_token', accessToken);
      
      const data = await addToGoogleCalendar(finalAppointmentId);
      
      // Restore original tokens if they existed
      if (originalToken) {
        localStorage.setItem('access_token', originalToken);
      } else {
        localStorage.removeItem('access_token');
      }
      
      if (originalSessionToken) {
        sessionStorage.setItem('access_token', originalSessionToken);
      } else {
        sessionStorage.removeItem('access_token');
      }
      
      const redirectUrl = data?.google_calendar_url;
      if (redirectUrl) {
        window.location.href = redirectUrl;
      } else {
        toast.error('No Google Calendar URL received from server');
      }
    } catch (error: any) {
      console.error('Failed to add to calendar:', error);
      toast.error(error.message || 'Failed to add to calendar. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="add-to-calendar-container">
      <button 
        className="add-to-calendar-button"
        onClick={handleAddToCalendar}
        disabled={isLoading}
      >
        {isLoading ? 'Adding to Calendar...' : 'Add to Calendar'}
      </button>
    </div>
  );
};

export default AddToCalendar;
